// extracted by mini-css-extract-plugin
module.exports = {"fare-rating":"fare-ratings_fare-rating__m2dVH","fare":"fare-ratings_fare__D5mQB","rating":"fare-ratings_rating__IAAPq","numbers":"fare-ratings_numbers__GTCPn"};